import { render, staticRenderFns } from "./Indicadores.vue?vue&type=template&id=1d82dc28&scoped=true"
import script from "./Indicadores.vue?vue&type=script&lang=js"
export * from "./Indicadores.vue?vue&type=script&lang=js"
import style0 from "./Indicadores.vue?vue&type=style&index=0&id=1d82dc28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d82dc28",
  null
  
)

export default component.exports